export const selectIsFetching = state => state.auth.isFetching;

export const selectLoginErrors = state => state.auth.errors.login || null;
export const selectRegistrationErrors = state =>
  state.auth.errors.registration || null;
export const selectResetPasswordErrors = state =>
  state.auth.errors.resetPassword || null;
